import getMenuItems, { MenuItemsCA } from 'routes/menu-items';
import useConfig from 'hooks/useConfig';
import { LayoutType, HORIZONTAL_MAX_ITEMS } from 'utils/constants';
import NavGroup from 'components/layout/MainLayout/MenuList/NavGroup/NavGroup';
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';
import { NavItemType } from 'models';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (menuItemsCA: MenuItemsCA) => {
  const theme = useTheme();
  const { layout } = useConfig();

  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  const navigation = getMenuItems({ menuItems: menuItemsCA });

  // last menu-item to show in horizontal menu bar
  const lastItem =
    layout === LayoutType.HORIZONTAL_LAYOUT && !matchDownMd
      ? HORIZONTAL_MAX_ITEMS
      : undefined;

  let lastItemIndex = navigation.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string | undefined;

  if (lastItem && lastItem < navigation.items.length) {
    lastItemId = navigation.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = navigation.items
      .slice(lastItem - 1, navigation.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children
      }));
  }

  const navItems = navigation.items.slice(0, lastItemIndex + 1).map((item) => {
    return item.type === 'group' ? (
      <NavGroup
        key={item.id}
        item={item}
        lastItem={lastItem}
        remItems={remItems}
        lastItemId={lastItemId}
      />
    ) : (
      <Typography key={item.id} variant='h6' color='error' align='center'>
        Menu Items Error
      </Typography>
    );
  });

  return <>{navItems}</>;
};

export default MenuList;
